import type { EditorAPI } from '#packages/editorAPI';
import { constants } from '#packages/platform';
import { MEMBERS_AREA_V2 } from '@wix/app-definition-ids';
import type { PagesData } from 'types/documentServices';

const SM_FORMS_TPA_PAGE_IDS = {
  LOGIN: 'loginTPA',
  SIGNUP: 'signupTPA',
};

export const hasCustomSignupLightbox = (editorAPI: EditorAPI): boolean => {
  const getCustomSignupPageId =
    editorAPI.dsRead.siteMembers.getCustomSignupPageId();
  const customSignupPage = editorAPI.components.get.byId(getCustomSignupPageId);

  const children =
    (customSignupPage && editorAPI.components.getChildren(customSignupPage)) ||
    [];
  return children.some(
    (childRef) =>
      editorAPI.components.getType(childRef) ===
        constants.FORM_COMPONENT_TYPE ||
      editorAPI.components.getType(childRef) === constants.POPUP_COMPONENT_TYPE,
  );
};

export const hasCustomSignInLightbox = (editorAPI: EditorAPI): boolean => {
  const getCustomSignInPageId =
    editorAPI.dsRead.siteMembers.getCustomSignInPageId();
  const customSignInPage = editorAPI.components.get.byId(getCustomSignInPageId);

  const children =
    (customSignInPage && editorAPI.components.getChildren(customSignInPage)) ||
    [];
  return children.some(
    (childRef) =>
      editorAPI.components.getType(childRef) === constants.POPUP_COMPONENT_TYPE,
  );
};

export const hasSmFormsAppPages = (editorAPI: EditorAPI): boolean => {
  const popupsData = editorAPI.pages.popupPages.getDataList();

  const hasLoginPage = popupsData.some(
    (page: PagesData) => page?.tpaPageId === SM_FORMS_TPA_PAGE_IDS.LOGIN,
  );
  const hasSignupPage = popupsData.some(
    (page: PagesData) => page?.tpaPageId === SM_FORMS_TPA_PAGE_IDS.SIGNUP,
  );

  return hasLoginPage && hasSignupPage;
};

const somePageIsRestrictedOrNewMA = (pagesData: PagesData[]): boolean =>
  pagesData.some(
    (data) =>
      data.pageSecurity?.requireLogin ||
      data.appDefinitionId === MEMBERS_AREA_V2,
  );

export const hasLegacyAuthScreens = (editorAPI: EditorAPI): boolean => {
  if (
    hasCustomSignupLightbox(editorAPI) ||
    hasCustomSignInLightbox(editorAPI)
  ) {
    return true;
  }
  const pagesData = editorAPI.dsRead.pages.getPagesData();
  const hasRestrictedPageOrNewMA = somePageIsRestrictedOrNewMA(pagesData);
  return hasRestrictedPageOrNewMA && !hasSmFormsAppPages(editorAPI);
};

export const shouldShowSignupTab = (editorAPI: EditorAPI): boolean => {
  const pagesData = editorAPI.dsRead.pages.getPagesData();
  const hasRestrictedPageOrNewMA =
    editorAPI.isDesktopEditor() && somePageIsRestrictedOrNewMA(pagesData);

  return (
    hasRestrictedPageOrNewMA ||
    hasCustomSignupLightbox(editorAPI) ||
    hasCustomSignInLightbox(editorAPI)
  );
};
